import React from "react";

const TiltText = (props) => {
    return (
        <div
            id="tiltDiv"
            ref={props.abc}
            className="text-white absolute top-[30%] md:top-[5%] transform flex flex-col items-center justify-center -translate-y-10"
        >
            {/* First Heading */}
            <h1 className="
                text-[12vw] 
                max-[1024px]:text-[13vw] 
                max-[768px]:text-[14vw] 
                max-[500px]:text-[16vw] 
                uppercase font-[anzo] text-center
            ">
                I am <span className="text-blue-300">LIGHT MODE</span>
            </h1>

            {/* Second Heading */}
            <h1 className="
                text-[17vw] 
                max-[1024px]:text-[18vw] 
                max-[768px]:text-[19vw] 
                max-[500px]:text-[20vw] 
                leading-[5vw] max-[768px]:leading-[6vw] max-[500px]:leading-[7vw]
                font-[anzo] text-center
            ">
                DEVELOPER
            </h1>

            {/* Third Heading */}
            <h1 className="
                text-[12vw] 
                max-[1024px]:text-[10vw] 
                max-[768px]:text-[8vw] 
                max-[500px]:text-[16vw] 
                uppercase font-[anzo] text-center
            ">
                To Hire
            </h1>
        </div>
    );
};

export default TiltText;
